;(() => {
	function getRoot(section) {
		return (
			(document.currentScript && document.currentScript.parentElement) ||
			section ||
			document
		)
	}

	const initSlider = (section) => {
		const root = getRoot(section)
		const testimonialsSlider = root.querySelector('.testimonials__slider')
		if (!testimonialsSlider) {
			return
		}

		const navigation = root.querySelector('.testimonials__navigation')
		const pagination = root.querySelector('.testimonials__pagination')
		const columns = Number(testimonialsSlider.dataset.columns)
		let columns750
		if (columns > 1) columns750 = columns - 1
		else columns750 = columns

		let swiperParams = {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 24,
			mousewheel: {
				forceToAxis: true,
			},
			breakpoints: {
				750: {
					slidesPerView: columns750,
					slidesPerGroup: columns750,
				},
				1200: {
					slidesPerView: columns,
					slidesPerGroup: columns,
				},
			},
		}

		if (testimonialsSlider.getAttribute('data-pagination') === 'true' && pagination) {
			swiperParams.pagination = {
				el: pagination,
				type: 'bullets',
				clickable: true,
			}
		}

		if (testimonialsSlider.getAttribute('data-navigation') === 'true' && navigation) {
			swiperParams.navigation = {
				nextEl: navigation.querySelector('.swiper-button-next'),
				prevEl: navigation.querySelector('.swiper-button-prev'),
			}
		}

		new Swiper(testimonialsSlider, swiperParams)
	}

	const initMarqueeDesktop = (section) => {
		const root = getRoot(section)
		const testimonialsMarquee = root.querySelectorAll('.testimonials__marquee-swiper')

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				const slides = slider.querySelectorAll('.swiper-slide')
				let sum = 0
				slides.forEach((slide) => {
					slide.style.height = slide.clientHeight + 'px'
					sum = sum + slide.clientHeight + 24
				})
				sum = sum - 24

				if (slides.length > 0) {
					let i = 0
					while (sum < slider.clientHeight * 2) {
						if (i > slides.length - 1) {
							i = 0
						}
						let clone = slider.querySelectorAll('.swiper-slide')[i].cloneNode(true)
						slider.querySelector('.swiper-wrapper').append(clone)
						i++
						sum = sum + clone.clientHeight + 24
					}
				}

				new Swiper(slider, {
					slidesPerView: 'auto',
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initMarqueeMobile = (section) => {
		const root = getRoot(section)
		const testimonialsMarquee = root.querySelectorAll(
			'.testimonials__marquee-swiper_mobile'
		)

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				new Swiper(slider, {
					slidesPerView: 3,
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initSection = (section) => {
		const sectionTestimonials = getRoot(section)
		if (!sectionTestimonials || sectionTestimonials === document) {
			const found = document.querySelector('.testimonials')
			if (!found) {
				return
			}
		}

		const observeTarget =
			sectionTestimonials === document
				? document.querySelector('.testimonials')
				: sectionTestimonials

		if (!observeTarget) {
			return
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width > 989) {
				const sliders = entry.target.querySelectorAll('.testimonials__marquee-swiper')
				if (sliders.length != 0) {
					sliders.forEach((slider) => {
						if (slider.swiper) slider.swiper.destroy()
					})
				}

				initMarqueeDesktop(observeTarget)
			} else {
				const sliderMobile = entry.target.querySelector(
					'.testimonials__marquee-swiper_mobile'
				)
				if (sliderMobile) {
					if (sliderMobile.swiper) sliderMobile.swiper.destroy()
				}

				initMarqueeMobile(observeTarget)
			}
		})

		sectionResizeObserver.observe(observeTarget)
	}

	function bootTestimonials() {
		initSlider()
		initMarqueeDesktop()
		initMarqueeMobile()
		initSection()
	}

	if (window.themeSwiperReady) {
		window.themeSwiperReady.then(bootTestimonials).catch(function () {})
	} else {
		bootTestimonials()
	}

	document.addEventListener('shopify:section:load', function (section) {
		function reloadSection() {
			initSlider(section.target)
			initMarqueeDesktop(section.target)
			initMarqueeMobile(section.target)
			initSection(section.target)
		}
		if (window.themeSwiperReady) {
			window.themeSwiperReady.then(reloadSection).catch(function () {})
		} else {
			reloadSection()
		}
	})
})()
